/**
 * Adds a useful fallback placeholder only where a Dizzign Globo form has a
 * visible field label but no placeholder. The underlying form settings and
 * submission data stay unchanged.
 */
const formSelector = '.globo-form-app[data-id="106289"], .globo-form-app[data-id="106298"]';

function addFallbackPlaceholders() {
  let fieldsFound = 0;

  document.querySelectorAll(formSelector).forEach((form) => {
    form.querySelectorAll('.globo-form-control').forEach((control) => {
      const label = control.querySelector('.globo-label .label-content');
      const field = control.querySelector(
        'input.material_filled-input:not([type="hidden"]), textarea.material_filled-input'
      );

      if (!label || !field) return;

      fieldsFound += 1;

      if (field.placeholder.trim()) return;

      const labelText = label.textContent.trim();
      if (labelText) field.placeholder = labelText;
    });

    if (form.dataset.id === '106298') improveWeddingForm(form);
  });

  return fieldsFound;
}

function improveWeddingForm(form) {
  keepFormHeaderCopy(
    form,
    'Tell Izzie about your wedding',
    'It takes around two minutes. Izzie will reply within 48 hours.'
  );

  form.querySelectorAll('.globo-form-control').forEach((control) => {
    const label = control.querySelector('.globo-label .label-content');
    const labelText = label?.textContent.trim().toLowerCase();

    if (labelText === 'choose package') {
      const select = control.querySelector('select.material_filled-input');
      const firstOption = select?.querySelector('option[value=""]');
      if (firstOption) firstOption.textContent = 'Select a package';
    }

    if (labelText === 'wedding date') {
      const dateField = control.querySelector('input.material_filled-input');
      if (!dateField) return;

      if (dateField.value === '01/06/2026') dateField.value = '';
      dateField.removeAttribute('data-default-input-value');
      dateField.type = 'date';
      dateField.setAttribute('aria-label', 'Wedding date');
    }

    if (labelText === 'final checks') {
      const terms = control.querySelector('.help-text.globo-description');
      if (terms?.textContent.includes('terms-and-conditions')) {
        terms.replaceChildren('Please read the ', createTermsLink(), '.');
      }
    }
  });

  const submitButton = form.querySelector('button.action.submit');
  if (submitButton) {
    submitButton.dataset.submitText = '<span class="spinner"></span>Check availability';
    submitButton.innerHTML = '<span class="spinner"></span>Check availability';
  }

  const footer = form.querySelector('.gfb__footer, .footer');
  if (footer && !footer.querySelector('.dizzign-form-reassurance')) {
    const reassurance = document.createElement('p');
    reassurance.className = 'dizzign-form-reassurance';
    reassurance.textContent = 'No obligation. Your details are only used to respond to your enquiry.';
    footer.append(reassurance);
  }
}

function keepFormHeaderCopy(form, headingText, descriptionText) {
  const applyCopy = () => {
    const heading = form.querySelector('.globo-heading');
    const description = form.querySelector('.header .globo-description');

    if (heading && heading.textContent.trim() !== headingText) heading.textContent = headingText;
    if (description && description.textContent.trim() !== descriptionText) {
      description.textContent = descriptionText;
    }
  };

  applyCopy();

  if (form.dataset.dizzignHeaderCopyObserver) return;
  form.dataset.dizzignHeaderCopyObserver = 'true';

  const observer = new MutationObserver(applyCopy);
  observer.observe(form, { childList: true, subtree: true, characterData: true });
}

function createTermsLink() {
  const link = document.createElement('a');
  link.href = '/pages/terms-and-conditions.html';
  link.textContent = 'Terms & Conditions';
  return link;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startFallbackPlaceholders, { once: true });
} else {
  startFallbackPlaceholders();
}

function startFallbackPlaceholders() {
  let attempts = 0;
  const interval = window.setInterval(() => {
    attempts += 1;
    // Globo progressively mounts and may replace its heading after the first
    // fields appear. Reapply the idempotent draft-theme enhancements briefly
    // while it finishes initialising instead of stopping at the first field.
    addFallbackPlaceholders();
    if (attempts >= 20) window.clearInterval(interval);
  }, 250);
}
